import React, { useEffect } from 'react'
import { makeAutoObservable } from 'mobx'
import { observer } from 'mobx-react-lite'
import MessagingWidget from './../../../../components/messaging/MessagingWidget/MessagingWidget.component'
import AdminApi from './../../../../api/admin-api/admin-api'
import AlertMessage from './../AlertMessage/AlertMessage.component'

import './DashboardMessages.scss'

class MessagingStore {
  message = null
  alertType = null
  loaded = {
    dashboard: true, // we always show dashboard messages widget on the dashboard.
    leader: null,
    division: null,
    alert: null,
  }

  constructor() {
    makeAutoObservable(this)
  }

  fetchAlert = async () => {
    return new Promise((resolve, reject) => {
      this.message = false
      AdminApi.getMessageBoardAlert()
        .then(result => {
          if (parseInt(result?.data?.data?.active) === 1) {
            const { message, alert_type } = result?.data?.data || {}
            this.message = message
            this.alertType = alert_type
            return resolve(message)
          }
          return resolve('')
        })
        .catch(error => reject(error))
    })
  }
}

const Store = new MessagingStore()

const DashboardMessages = ({ activeDivisionId, onSuccess, onError }) => {
  const { message, alertType, fetchAlert, loaded } = Store

  useEffect(() => {
    if (message === null)
      fetchAlert().then(
        msg => onSuccess(),
        () => onError()
      )
  }, [message, fetchAlert, onError, onSuccess])

  return (
    <div id='DashboardMessagesComponent'>
      <AlertMessage message={message} alertType={alertType} />
      {message ? <br /> : <></>}
      <MessagingWidget
        viewerName={'USABG'}
        category='dashboard'
        isHomepageBoard={true}
        onSuccess={() => {
          Store.loaded.dashboard = true
          onSuccess({ dashboard: true })
        }}
        onError={() => {
          Store.loaded.dashboard = false
          onError({ dashboard: false })
        }}
      />
      {loaded.dashboard ? <br /> : <></>}
      <MessagingWidget
        viewerName={'Leader'}
        isHomepageBoard={true}
        hideIfEmpty={true}
        headerColor={'leaf-green'}
        category={'leader'}
        onSuccess={() => {
          Store.loaded.leader = true
          onSuccess({ leader: true })
        }}
        onError={() => {
          Store.loaded.leader = false
          onError({ leader: false })
        }}
      />
      {loaded.leader ? <br /> : <></>}
      <MessagingWidget
        viewerName={'Division'}
        division_id={activeDivisionId}
        isHomepageBoard={true}
        hideIfEmpty={true}
        headerColor={'sky-blue'}
        category={'division'}
        onSuccess={() => {
          Store.loaded.division = true
          onSuccess({ division: true })
        }}
        onError={() => {
          Store.loaded.division = false
          onError({ division: false })
        }}
      />
      {loaded.division ? <br /> : <></>}
    </div>
  )
}

export default observer(DashboardMessages)
